import React from "react";
import useButtonLoader from "../../hooks/UseButtonLoader";
import ModalBox from "../../components/modal/ModalBox";
import toast from "react-hot-toast";
import { changeCommunityStatusApi } from "../../services/community";

const ChangeCommunityStatus = ({ show, close, status, id, listing, name }) => {
  const [buttonref, buttonLoader] = useButtonLoader("Yes");

  //--------------change-status-Product-------------------------
  const changeStatus = async () => {
    try {
      buttonLoader(true);
      let data = { status: !status, id: id };
      const res = await changeCommunityStatusApi(data);
      if (res.data.status === 200) {
        toast.success(res.data.message);
        close();
        buttonLoader(false);
        listing();
      } else {
        toast.error(res.data.message);
        buttonLoader(false);
      }
    } catch (e) {
      toast.error(e.message);
      buttonLoader(false);
    }
  };
  return (
    <ModalBox
      status={show}
      onClose={close}
      title={`${status ? "Block" : "Unblock"} Community`}
      description={
        <span>
          Do you want to {!status ? "Unbolck" : "block"} <strong>{name}</strong>{" "}
          ?
        </span>
      }
      action={changeStatus}
      // ref={buttonref}
    />
  );
};

export default ChangeCommunityStatus;
